import React from 'react';
import PropTypes from 'prop-types';
import { Button, Link } from 'anf-core-react';

const ShopAllButton = ({
  shopAllLabel, brand, onClick, isMobile,
}) => (
  <div className="shop-all-button-container">
    {isMobile ? (
      <Link className="link-button" brand={brand} onClick={onClick}>
        {shopAllLabel}
      </Link>
    ) : (
      <Button variant="secondary" brand={brand} onClick={onClick}>
        {shopAllLabel}
      </Button>
    )}
  </div>
);

ShopAllButton.propTypes = {
  shopAllLabel: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ShopAllButton;
